import TextField from "@mui/material/TextField";
import React from "react";

const CustomTextField = ({ ...props }) => {
  const [error, setError] = React.useState(false);
  let helperText = props.helperText;
  if (helperText == "no") {
    helperText = "";
  } else {
    if (helperText == "" || helperText == undefined) {
      helperText = "Please fill the field";
    }
  }

  const handleOnblur = (e: any) => {
    if (e.target.required && e.target.value == "") {
      setError(true);
    } else {
      setError(false);
    }
  };

  return (
    <TextField
      {...props}
      variant="outlined"
      error={error ? true : false}
      helperText={error ? helperText : ""}
      onBlur={handleOnblur}
    />
  );
};

export default CustomTextField;
